var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, Text } from '@ui';
import { useAttachmentFieldCommit } from '../hooks/useAttachmentFieldCommit';
/**
 * The `Show on report` cell — the one editable field this surface has besides the name.
 *
 * Only uploaded attachments have the column at all, so a generated document renders an em dash
 * rather than an unchecked box: an unchecked box is a claim that the row HAS the setting and it is
 * off, which is a different and false statement, and it would invite a click that 422s.
 */
export function ShowOnReportCell({ item, workOrderId, translateFn }) {
    const { commit } = useAttachmentFieldCommit(workOrderId, item.id);
    const [checked, setChecked] = useState(Boolean(item.showOnReport));
    // While a commit is in flight the row in the list cache still holds the old value; without this
    // guard the effect below would stomp the optimistic state back on the next render.
    const isSavingRef = useRef(false);
    useEffect(() => {
        if (isSavingRef.current)
            return;
        setChecked(Boolean(item.showOnReport));
    }, [item.showOnReport]);
    if (item.showOnReport === null) {
        return (React.createElement(Text, { variant: "body", "aria-label": translateFn('show_on_report.not_applicable') }, "\u2014"));
    }
    const handleChange = (next) => __awaiter(this, void 0, void 0, function* () {
        isSavingRef.current = true;
        setChecked(next);
        const result = yield commit({ showOnReport: next });
        isSavingRef.current = false;
        // Revert on failure: the checkbox is controlled, so the only honest way to show the write did
        // not land is to put it back where it was.
        if (!result.success)
            setChecked(!next);
    });
    return (React.createElement(Checkbox, { id: `show-on-report-${item.id}`, checked: checked, onChange: (next) => {
            void handleChange(next);
        }, label: "", "aria-label": translateFn('show_on_report.aria_label') }));
}
